import * as React from "react";
const SvgFiRrCediSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.19 16.12c-.49-.25-1.09-.06-1.35.43A6.35 6.35 0 0 1 13.18 20H13V4h.18c2.43 0 4.62 1.35 5.7 3.54.25.49.85.7 1.34.45s.7-.85.45-1.34A8.32 8.32 0 0 0 13.18 2H13V1c0-.55-.45-1-1-1s-1 .45-1 1v1.01c-4.44.19-8 3.87-8 8.35v3.27c0 4.49 3.56 8.16 8 8.35v1.01c0 .55.45 1 1 1s1-.45 1-1v-1h.18c3.14 0 5.99-1.74 7.43-4.53.25-.49.06-1.09-.43-1.35zM5 13.63v-3.27c0-3.39 2.66-6.16 6-6.35v15.98c-3.34-.19-6-2.97-6-6.35z"
    />
  </svg>
);
export default SvgFiRrCediSign;
